import { hasWindow } from "@omni/utils/dom.utils";
import { isDefined } from "@omni/utils/helper.utils";

import { useWoosmapScript } from "@/services/woosmap/woosmap.initializer";
import { memoizeObject } from "@/utils/memoize";

const woosmapServices: {
    LocalitiesService?: woosmap.map.LocalitiesService;
    StoresService?: woosmap.map.StoresService;
    DistanceService?: woosmap.map.DistanceService;
    DirectionsService?: woosmap.map.DirectionsService;
} = {};

export const useWoosmapServices = () => {
    useWoosmapScript();

    if (!hasWindow()) return {};
    if (!isDefined(window?.woosmap?.map)) return {};

    woosmapServices.LocalitiesService ||= memoizeObject(
        new woosmap.map.LocalitiesService()
    );
    woosmapServices.StoresService ||= memoizeObject(
        new woosmap.map.StoresService()
    );
    woosmapServices.DistanceService ||= memoizeObject(
        new woosmap.map.DistanceService()
    );
    woosmapServices.DirectionsService ||= new woosmap.map.DirectionsService();

    return {
        LocalitiesService: woosmapServices.LocalitiesService,
        StoresService: woosmapServices.StoresService,
        DistanceService: woosmapServices.DistanceService,
        DirectionsService: woosmapServices.DirectionsService
    };
};
